<div class="header">
  <div class="title" data-cy="custom-object-modal-title">{{ customObject ? 'Edit' : 'Add New' }} Object</div>
  <button class="close-button" mat-icon-button (click)="close()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="addObjectForm">
  <div class="fields">
    <mat-form-field>
      <mat-label>Object Name</mat-label>
      <input data-cy="custom-object-name" matInput formControlName="label" autocomplete="off" />
      <mat-error *ngIf="labelControl.hasError('invalidCOName')">{{ nameError }}.</mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Object Label (Plural)</mat-label>
      <input
        matInput
        [ngModel]="addObjectForm.get('label').value | pluralize"
        formControlName="label_plural"
        autocomplete="off"
      />
    </mat-form-field>
  </div>

  <div class="actions">
    <!-- Discard -->
    <button class="cancel-button" mat-button type="button" (click)="close()">
      <span>Cancel</span>
    </button>

    <!-- Add -->
    <button
      class="save-button"
      data-cy="custom-object-save-button"
      mat-flat-button
      [color]="'primary'"
      type="submit"
      [disabled]="isSaveBtnDisabled"
      DebounceClick
      (debounceLoading)="isDebounceLoading($event)"
      (debounceClick)="saveAndClose()"
    >
      <span *ngIf="!isLoading">Save</span>
      <mat-progress-spinner *ngIf="isLoading" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
    </button>
  </div>
</form>
